import React from 'react';

interface AccessDeniedProps {
  title?: string;
  message?: string;
  className?: string;
  children?: React.ReactNode;
}

const AccessDenied: React.FC<AccessDeniedProps> = ({
  title = 'Access Restricted',
  message = 'You do not have permission to view this section.',
  className = '',
  children,
}) => {
  return (
    <div className={`bg-white shadow-sm rounded-lg border border-red-100 p-8 text-center ${className}`}>
      <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-red-50 text-red-600 mb-4">
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01M4.93 4.93l14.14 14.14" />
        </svg>
      </div>
      <h2 className="text-xl font-semibold text-gray-900 mb-2">{title}</h2>
      <p className="text-gray-600 mb-4">{message}</p>
      {children && <div className="mt-4">{children}</div>}
    </div>
  );
};

export default AccessDenied;

